import { useMemo, useState } from 'react';
import type { FunctionComponent } from 'react';
import ConceptsDialog from '../../components/organisms/ConceptsDialog';
import type { CategoryKey, Concept, Concepts } from '../../data/Concepts';
import { getIntroConcept } from './defaults';

export interface StateProps {
	concepts: Concepts;
	activeConcepts: Concepts;
	defaultCategory: CategoryKey;
}

export interface DispatchProps {}

export interface OwnProps {
	onClose: () => void;
	onConcept: (concept: Concept) => void;
	onActivate: (concept: Concept) => void;
}

type Props = StateProps & DispatchProps & OwnProps;

const ConceptsIntroScreen: FunctionComponent<Props> = (props: Props) => {
	const {
		concepts,
		activeConcepts,
		defaultCategory,
		onClose,
		onConcept,
		onActivate
	} = props;
	const enabledConcept = useMemo(() => getIntroConcept(), []);
	const [currentCategory, setCurrentCategory] = useState(defaultCategory);

	return (
		<ConceptsDialog
			concepts={concepts}
			activeConcepts={activeConcepts}
			enabledConcepts={[enabledConcept]}
			currentCategory={currentCategory}
			onCurrentCategoryChange={(category) => setCurrentCategory(category)}
			onClose={onClose}
			onActivate={onActivate}
			onConcept={onConcept}
		/>
	);
};

export default ConceptsIntroScreen;
